export default [
  {
    name: 'RealEstateDevelopmentsList',
    path: 'real-estate-developments',
    component: () => import('pages/real-estate-developments/RealEstateDevelopmentsList.vue')
  },
  {
    name: 'RealEstateDevelopmentsSingleLayout',
    path: '/real-estate-developments/:id',
    redirect: { name: 'RealEstateDevelopmentsUnitsList' },
    component: () => import('pages/real-estate-developments/single/_layouts/RealEstateDevelopmentsSingleLayout.vue'),
    children: [
      {
        path: 'units',
        name: 'RealEstateDevelopmentsUnitsList',
        component: () => import('pages/real-estate-developments/single/tabs/RealEstateDevelopmentsUnitsList.vue'),
        meta: {
          slug: 'units',
          useCache: false // removido pois os filtros dependem de id dinâmico.
        }
      },
      {
        path: 'characteristics',
        name: 'RealEstateDevelopmentsCharacteristicsSingle',
        component: () => import('pages/real-estate-developments/single/tabs/RealEstateDevelopmentsCharacteristicsSingle.vue'),
        meta: { slug: 'characteristics' }
      },
      {
        path: 'documents',
        name: 'RealEstateDevelopmentsDocumentsList',
        component: () => import('pages/real-estate-developments/single/tabs/RealEstateDevelopmentsDocumentsList.vue'),
        meta: { slug: 'documents' }
      },
      {
        path: 'medias',
        name: 'RealEstateDevelopmentsMediasSingle',
        component: () => import('pages/real-estate-developments/single/tabs/RealEstateDevelopmentsMediasSingle.vue'),
        meta: { slug: 'medias' }
      },
      {
        path: 'interests',
        name: 'RealEstateDevelopmentsInterestsList',
        component: () => import('pages/real-estate-developments/single/tabs/RealEstateDevelopmentsInterestsList.vue'),
        meta: { slug: 'interests' }
      },
      {
        path: 'reservations',
        name: 'RealEstateDevelopmentsReservationsList',
        component: () => import('pages/real-estate-developments/single/tabs/RealEstateDevelopmentsReservationsList.vue'),
        meta: { slug: 'reservations' }
      }
    ]
  },
  {
    path: '/real-estate-developments/:id/units/:unitId/sales/new',
    name: 'SalesCreate',
    component: () => import('pages/sales/form/SalesForm.vue')
  },
  {
    path: '/real-estate-developments/:id',
    name: 'SalesSingleLayout',
    component: () => import('layouts/SalesSingleLayout.vue'),
    children: [
      {
        path: 'units/:unitId/sales/:saleId/edit',
        name: 'SalesEdit',
        meta: { useOverlay: true },
        component: () => import('pages/sales/form/SalesForm.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/documents',
        name: 'SalesDocuments',
        meta: { useOverlay: true },
        component: () => import('pages/sales/documents/SalesDocumentsList.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/contracts',
        name: 'SalesContractsSingle',
        meta: { useOverlay: true },
        component: () => import('src/pages/sales/contracts/SalesContractsSingle.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/additive',
        name: 'SalesAdditive',
        meta: { useOverlay: true },
        component: () => import('pages/sales/SalesAdditive.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/assignment-of-rights',
        name: 'SalesAssignmentOfRightsList',
        meta: { useOverlay: true },
        component: () => import('pages/sales/assignment-of-rights/SalesAssignmentOfRightsList.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/history',
        name: 'SalesHistory',
        meta: { useOverlay: true },
        component: () => import('pages/sales/sales-history/SalesHistory.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/personalizations',
        name: 'PersonalizationsList',
        meta: { useOverlay: true },
        component: () => import('pages/sales/personalizations/PersonalizationsList.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/signal-payments',
        name: 'SalesSignalPayments',
        meta: { useOverlay: true },
        component: () => import('pages/sales/signal-payments/SalesSignalPaymentsSingle.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/sales-completions',
        name: 'SalesCompletionsSingle',
        component: () => import('pages/sales/sales-completions/SalesCompletionsSingle.vue')
      }
    ]
  },
  {
    path: '/real-estate-developments/:id',
    children: [
      {
        path: 'units/:unitId/sales/:saleId/assignment-of-rights/:assignmentOfRightsId/edit',
        name: 'SalesAssignmentOfRightsEdit',
        component: () => import('pages/sales/assignment-of-rights/SalesAssignmentOfRightsEdit.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/personalizations/new',
        name: 'PersonalizationsCreate',
        component: () => import('pages/sales/personalizations/PersonalizationsCreate.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/personalizations/:personalizationId',
        name: 'PersonalizationsSingle',
        component: () => import('pages/sales/personalizations/PersonalizationsSingle.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/personalizations/additives/:personalizationId',
        name: 'PersonalizationsAdditiveSingle',
        component: () => import('pages/sales/personalizations/PersonalizationsSingle.vue')
      },
      {
        path: 'units/:unitId/sales/:saleId/personalizations/additives/new',
        name: 'PersonalizationsAdditiveCreate',
        component: () => import('pages/sales/personalizations/PersonalizationsCreate.vue')
      },
      {
        path: 'units/:unitId/interests/new',
        name: 'InterestsForm',
        component: () => import('pages/sales-record/SalesRecordForm.vue')
      },
      {
        path: 'units/:unitId/reservation/new',
        name: 'ReservationForm',
        component: () => import('pages/sales-record/SalesRecordForm.vue')
      }
    ]
  }
]
